import React from 'react'
//import RictaLogo from '../../images/rictaLogo.svg'
import Fade from 'react-reveal/Fade'

const Introduction = () => {
    return (
        <header className=" bg-no-repeat bg-center bg-cover resize">
            <div className=" py-12 bg-opacity-50 bg-white flex items-center justify-center max-w-screen-xl w-4/5 md:w-full m-auto" style={{background:'rgba(0,0,0,0.0)'}}>
                <div className="mx-2 text-center">
                    {/* <Fade left>
                        <img src={RictaLogo} className="rictaLogo"/>
                    </Fade> */}
                    <Fade left>
                        <h1 className="text-mainColor whitespace-normal break-words font-bold mt-10 text-xl md:text-3xl lg:text-4xl">
                A Software Boutique company with focus on developing new browsing solutions for <br/> Forensic specialists and OSINT analysts.
                        </h1>
                    </Fade>
                </div>
            </div>
        </header>
    )

}
export default Introduction
